import { render, staticRenderFns } from "./emojiPopover.vue?vue&type=template&id=14f6340f"
import script from "./emojiPopover.vue?vue&type=script&lang=js"
export * from "./emojiPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f6340f')) {
      api.createRecord('14f6340f', component.options)
    } else {
      api.reload('14f6340f', component.options)
    }
    module.hot.accept("./emojiPopover.vue?vue&type=template&id=14f6340f", function () {
      api.rerender('14f6340f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emojiPopover.vue"
export default component.exports